import React from "react";

import { Helmet } from "react-helmet";

import { Orders } from "features/Orders";
import { PageTitle } from "shared/ui";

const TITLE = "Заказы";

// Тонкая обёртка над фичей: ставит chrome страницы и отдаёт всё остальное features/Orders.
const OrdersListPage = () => {
    return (
        <>
            <PageTitle>{TITLE}</PageTitle>
            <Helmet title={TITLE} />
            <Orders />
        </>
    );
};

export default OrdersListPage;
